import { FetchBaseError } from "./base.js";
class AbortError extends FetchBaseError {
  constructor(message, type = "aborted") {
    super(message, type);
  }
}
export {
  AbortError
};
//# sourceMappingURL=abort-error.js.map
